import { createId } from "@paralleldrive/cuid2";

export const generateId = (prefix: string): string => {
  return `${prefix}_${createId()}`;
};

export const generateQuoteLineId = (): string => {
  return generateId("ql");
};
